import Ajax from '@/lib/ajax'
export default {
  /**
   * 创建优惠券
   * @param data
   */
  addCoupon(data: any) {
    return Ajax.post(`/api/MarketingManagement/coupon`, data)
  },
  /**
   * 更新优惠券
   * @param id
   * @param data
   */
  updateCoupon(id: string, data: any) {
    return Ajax.put(`/api/MarketingManagement/coupon/${id}`, data)
  },
  /**
   * 获取优惠券信息
   * @param id
   */
  getCoupon(id: string) {
    return Ajax.get(`/api/MarketingManagement/coupon/${id}`)
  },
  getList(
    pageSize: number,
    currentPage: number,
    excludeBonusCoupon: boolean = false,
    keyWord?: string
  ) {
    let params = {
      keyWord: keyWord,
      ExcludeBonusCoupon: excludeBonusCoupon,
      MaxResultCount: pageSize,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize
    }

    return Ajax.get('/api/MarketingManagement/coupon', {
      params: params
    })
  },
  getAppletsCouponList(
    pageSize: number,
    currentPage: number,
  ) {
    let params = {
      MaxResultCount: pageSize,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize
    }
    return Ajax.get('/api/MarketingManagement/coupon/PublishedLsit')
  },
}
